import { useCallback } from 'react';
import { providersService } from '../services';
import {
  useResourceCollection,
  useResourceById,
  useCreateResource,
  useUpdateResource,
  useDeleteResource,
  ResourceState,
  SingleResourceState,
  MutationState,
} from './useResource';
import { ResourceQueryOptions } from '../services/resources.service';
import { Provider } from '../types';

export function useProviders(
  options?: ResourceQueryOptions
): ResourceState<Provider> & { meta?: any } {
  const fetchFn = useCallback(
    (opts?: ResourceQueryOptions) =>
      providersService.getAll(opts) as unknown as Promise<{ data: Provider[]; meta?: any }>,
    []
  );
  return useResourceCollection<Provider>(fetchFn, options);
}

export function useProvider(
  id: string | null,
  options?: ResourceQueryOptions
): SingleResourceState<Provider> {
  const resourceId = id;
  const fetchFn = useCallback(
    (providerId: string | number, opts?: ResourceQueryOptions) =>
      providersService.getById(providerId, opts) as unknown as Promise<Provider>,
    []
  );
  return useResourceById<Provider>(fetchFn, resourceId, options);
}

export function useCreateProvider(
  onSuccess?: (data: Provider) => void
): MutationState<Provider> {
  const createFn = useCallback(
    (data: any) => providersService.create(data) as unknown as Promise<Provider>,
    []
  );
  return useCreateResource<Provider>(createFn, onSuccess);
}

export function useUpdateProvider(
  onSuccess?: (data: Provider) => void
): MutationState<Provider> {
  const updateFn = useCallback(
    (id: string | number, data: any) => {
      return providersService.update(id, data) as unknown as Promise<Provider>;
    },
    []
  );
  return useUpdateResource<Provider>(updateFn, onSuccess);
}

/**
 * Delete provider using documentId
 * @param data - Full provider object containing documentId
 */
export function useDeleteProvider(onSuccess?: () => void): MutationState<void> {
  const deleteFn = useCallback(
    (data: any) => {
      const documentId = data.documentId || data.id?.toString() || data.id;
      return providersService.delete(documentId) as unknown as Promise<void>;
    },
    []
  );
  return useDeleteResource(deleteFn, onSuccess);
}
// Auto-generated hook file
